
<table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource" style="margin-top: 20px">

    <ng-container matColumnDef="nome">
        <th mat-header-cell *matHeaderCellDef> Responsável </th>
        <td mat-cell *matCellDef="let element"> {{element.familiar.pessoasFisica.nome}} </td>
    </ng-container>

    <ng-container matColumnDef="dataVinculacao">
        <th mat-header-cell *matHeaderCellDef> Data vinculação </th>
        <td mat-cell *matCellDef="let element"> {{element.dataVinculacao | dataSimples}} </td>
    </ng-container>

    <ng-container matColumnDef="dataDesvinculacao">
        <th mat-header-cell *matHeaderCellDef> Data desvinculação</th>
        <td mat-cell *matCellDef="let element"> {{element.dataDesvinculacao | dataSimples}} </td>
    </ng-container>

    <ng-container matColumnDef="aluno">
        <th mat-header-cell *matHeaderCellDef> Aluno</th>
        <td mat-cell *matCellDef="let element" style="width: 350px"> {{element.aluno.pessoaFisica.nome}} </td>
    </ng-container>

    <ng-container matColumnDef="acoes">
        <th mat-header-cell *matHeaderCellDef> Ações </th>
        <td mat-cell *matCellDef="let element">
            <button *ngIf="perfilAcesso.deleta"  mat-button (click)="deletar(element)">
                <mat-icon>delete</mat-icon>
            </button>
            <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizar(element)">
                <mat-icon>create</mat-icon>
            </button>
        </td>
    </ng-container>    

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<div [hidden]="!mostrarTabela">
    <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
</div>

<ng-template #tabelaSemDados>
    <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px">
        {{msg}}
    </div>
</ng-template>

<div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-top: 30px">
    <div>
        <button matTooltip="Adicionar novo responsável" mat-fab color="primary" (click)="novo()">
            <mat-icon>add</mat-icon>
        </button>
    </div>
</div>
